import { render } from "./booking-2.vue?vue&type=template&id=85e2bdd4&scoped=true"
import script from "./booking-2.vue?vue&type=script&lang=js"
export * from "./booking-2.vue?vue&type=script&lang=js"

import "./booking-2.vue?vue&type=style&index=0&id=85e2bdd4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e2bdd4"]])

export default __exports__